export default __webpack_public_path__ + "static/media/about_img.7b12a901.png";